import { x } from '../utils';

function NetworkProvider(endpointName, fetch, subscribe, subscribeMultiple, config) {
    config = config || {};

    const buildConfig = function (identifier, versionTag, options) {
        let result = {};
        if (config) {
            result = x.clone(config);
        }

        result.name = endpointName;
        result.id = identifier;
        if (versionTag !== undefined) {
            result.versionTag = versionTag;
        }
        if (options && options.bypassQueue) {
            result.bypassQueue = true;
        }

        return result;
    };

    this.subscribe = (identifier, versionTag, onSubscribe, onUpdate, options) => {
        const socketEnablerConfig = buildConfig(identifier, versionTag, options);

        const tappedOnSubscribe = (err, type, data) => {
            // We can get errors
            if (err) {
                type = 'ERROR';
            }

            // onSubscribe should be called with (err, data)
            switch (type) {
                case 'ERROR':
                    onSubscribe(err || data || new Error('Unknown Error'), null);
                    break;
                case 'FULL':
                    onSubscribe(null, data);
                    break;
                case 'NOT_AVAILABLE':
                    onSubscribe('NOT_AVAILABLE', null);
                    break;
                case 'UP_TO_DATE':
                    onSubscribe(null, null);
                    break;
                default:
                    onSubscribe(
                        new Error(
                            `Unrecognized response from server: type = ${type}, data = ${JSON.stringify(
                                data
                            )}`
                        ),
                        null
                    );
            }
        };

        const tappedOnUpdate = (type, data) => {
            switch (type) {
                case 'DIFF':
                    onUpdate(null, data);
                    break;
                case 'FULL':
                    onUpdate(data, null);
                    break;
                case 'REMOVED':
                    onUpdate(null, null);
                    break;
                default:
                    throw new Error(
                        `Unrecognized response from server: type = ${type}, data = ${JSON.stringify(
                            data
                        )}`
                    );
            }
        };

        return subscribe(socketEnablerConfig, tappedOnSubscribe, tappedOnUpdate);
    };

    this.subscribeMultiple = (identifiers, versionTag, onSubscribe, onUpdate, options) => {
        const socketEnablerConfig = buildConfig(undefined, versionTag, options);
        socketEnablerConfig.ids = identifiers;

        const tappedOnSubscribe = (err, type, dataInfos) => {
            if (err) {
                type = 'ERROR';
            }

            switch (type) {
                case 'ERROR':
                    onSubscribe(err || new Error('Unknown Error'), null);
                    break;
                case 'MULTI': {
                    const dataPromises = dataInfos.map(dataInfo => {
                        return tappedOnItemData(dataInfo.type, dataInfo.data, dataInfo.id, true)
                            .then(data => ({id: dataInfo.id, data}))
                    });
                    Promise.all(dataPromises).then(items => onSubscribe(null, items))
                    break;
                }

                default:
                    onSubscribe(
                        new Error(
                            `Unrecognized response from server for multi subscription: type = ${type}, data = ${JSON.stringify(
                                dataInfos
                            )}`
                        )
                    );
            }
        };

        const tappedOnItemData = (type, data, itemId, skipPublish = false) => {
            switch (type) {
                case 'DIFF':
                    return onUpdate(null, data, itemId, skipPublish);
                case 'FULL':
                    return onUpdate(data, null, itemId, skipPublish);
                case 'REMOVED':
                    return onUpdate(null, null, itemId, skipPublish);
                case 'NOT_AVAILABLE':
                    return onUpdate(null, null, itemId, skipPublish, true);
                case 'UP_TO_DATE':
                    return onUpdate();
                default:
                    throw new Error(
                        `Unrecognized response from server: type = ${type}, data = ${JSON.stringify(
                            data
                        )}`
                    );
            }
        };

        return subscribeMultiple(socketEnablerConfig, tappedOnSubscribe, tappedOnItemData);
    };

    this.fetch = (identifier, onFetch, options = {}) =>
        fetch(buildConfig(identifier, null, options), onFetch);

    this.configure = configuration => {
        if (!configuration) {
            throw new Error('missing configuration object');
        }

        x.extend(config, configuration);
    };

    this.getConfiguration = () => x.clone(config);
}

export default NetworkProvider;
